import EmailPasswordLogin from './EmailPasswordLogin';
import EmailPasswordInvite from './EmailPasswordInvite';
import EmailPasswordSettings from './EmailPasswordSettings';

const emailPassword = {
  name: 'Email & Password',
  Login: EmailPasswordLogin,
  Settings: EmailPasswordSettings,
  Invite: EmailPasswordInvite
};

export default emailPassword;
